import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from '../../Components/navbar/navbar.component';
import { FooterComponent } from '../../Components/footer/footer.component';
@Component({
  selector: 'app-no-result-page',
  standalone: true,
  imports: [CommonModule, NavbarComponent, FooterComponent],
  templateUrl: './no-result-page.component.html',
  styleUrls: ['./no-result-page.component.css']
})
export class NoResultPageComponent implements OnInit {
  constructor() { }
  imgSrc = environment.imgBasURL;
  ngOnInit(): void {
  }

}
